import { render, staticRenderFns } from "./TableBox.vue?vue&type=template&id=26d3d030&scoped=true"
import script from "./TableBox.vue?vue&type=script&lang=js"
export * from "./TableBox.vue?vue&type=script&lang=js"
import style0 from "./TableBox.vue?vue&type=style&index=0&id=26d3d030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d3d030",
  null
  
)

export default component.exports